export const SET_MESSAGESHOW_FALSE = 'SET_MESSAGESHOW_FALSE';
export const SET_MESSAGESHOW_TRUE = 'SET_MESSAGESHOW_TRUE';
